module.exports = __webpack_public_path__ + "static/media/responseBtn.978f1b7b.png";